import { render, staticRenderFns } from "./AddSale.vue?vue&type=template&id=dc27a474&scoped=true&"
import script from "./AddSale.vue?vue&type=script&lang=js&"
export * from "./AddSale.vue?vue&type=script&lang=js&"
import style0 from "./AddSale.vue?vue&type=style&index=0&id=dc27a474&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc27a474",
  null
  
)

export default component.exports